// src/components/common/search/constants.ts

export const DEFAULT_AUTO_SEARCH_ENABLED = false as const;
export const DEFAULT_AUTO_SEARCH_DELAY_MS = 500 as const;
